export const genreService = {
    getGenreList
}


 function getGenreList():string[] {
   return ["Cyberpunk",
   "Hip-Hop",
   "Dubstep",
   "Alternative Rock",
   "Metal",
   "Israeli",
   "K-pop",
   "Epic",
  ] 
}